import apis from './axios.config'
const api = apis.AdMedicalApi

export default {
    CtrDep(t) {
        return api.post('MOC1/CtrDep', t)
    },

    DrugInfo(t) {
        return api.post('MOC1/DrugInfo', t)
    },

    PeoLogin(t) {
        return api.post('MOC1/PeoLogin', t)
    },

    PeoDataModify(t) {
        return api.post('MOC1/PeoDataModify', t)
    }
}